import { render } from "./ImageDisplayModal.vue?vue&type=template&id=199ad1ff&scoped=true"
import script from "./ImageDisplayModal.vue?vue&type=script&lang=js"
export * from "./ImageDisplayModal.vue?vue&type=script&lang=js"

import "./ImageDisplayModal.vue?vue&type=style&index=0&id=199ad1ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199ad1ff"]])

export default __exports__